export default __webpack_public_path__ + "static/media/state-detail.4b0c2b00.svg";